import React from 'react';
import PropTypes from 'prop-types';
import {
  BrowserRouter as Router,
  Route,
  Switch,
} from 'react-router-dom';
import ReactGA from 'react-ga';
import Landing from '../landing/landing';
import Dashboard from '../dashboard/dashboard';
import Guest from '../../containers/guest';
import Login from '../login/login';
import AppBar from '../../containers/app_bar';
import AppSnackbar from '../../containers/app_snackbar';
import AppFooter from '../app_footer/app_footer';
import FAQ from '../faq/faq';
import PrivacyPolicy from '../privacy_policy/privacy_policy';
import ProtectedRoute from '../protected_route/protected_route';
import './teamhub.scss';
import ChromecastManager from '../../services/chromecast/chromecast_manager';
import config from '../../config';

if (config.GOOGLE_TRACK_ID) ReactGA.initialize(config.GOOGLE_TRACK_ID);

export default class TeamHub extends React.Component {
  static propTypes = {
    user: PropTypes.object,
    pairChromecast: PropTypes.func.isRequired,
  };

  static defaultProps = {
    user: null,
  };

  componentWillMount() {
    if (this.props.user) {
      this._initChromecast();
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!this.props.user && nextProps.user) {
      this._initChromecast();
    }
  }

  _initChromecast() {
    ChromecastManager.init()
      .then(() => {
        ChromecastManager.onSessionChanged((session) => {
          if (session) {
            this.props.pairChromecast();
          }
        });
      });
  }

  render() {
    return (
      <Router>
        <div className="teamhub">
          <Route
            render={props => (
              <div className="teamhub">
                <AppBar currentPath={props.location.pathname} />

                <div className="app-content">
                  <Switch>
                    <Route exact path="/" component={Landing} />
                    <Route path="/login" component={Login} />
                    <Route path="/faq" component={FAQ} />
                    <Route path="/privacy_policy" component={PrivacyPolicy} />
                    <Route path="/guest" component={Guest} />
                    <ProtectedRoute path="/dashboard" Component={Dashboard} user={this.props.user} />
                  </Switch>

                  <AppSnackbar />
                </div>

                <div className="app-footer-wrapper">
                  <AppFooter currentPath={props.location.pathname} />
                </div>
              </div>
            )}
          />
        </div>
      </Router>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/teamhub/teamhub.jsx